import React from 'react'
import SanityLink from './SanityLink'
import clsx from 'clsx'

export default function CTA({ link, className, style, arrow }) {
	return (
		<SanityLink
			className={clsx(className, style)}
			{...link}
			arrow={arrow} />
	)
}
